/* eslint-disable @typescript-eslint/no-explicit-any */
var DataType;
(function (DataType) {
    DataType["Number"] = "number";
    DataType["String"] = "string";
    DataType["Boolean"] = "boolean";
    DataType["Undefined"] = "undefined";
    DataType["Null"] = "null";
    DataType["Symbol"] = "symbol";
    DataType["Object"] = "object";
    DataType["Date"] = "date";
    DataType["Map"] = "map";
    DataType["Set"] = "set";
    DataType["BigInt"] = "bigint";
    DataType["Function"] = "function";
    DataType["Promise"] = "promise";
    DataType["File"] = "file";
    DataType["Blob"] = "blob";
})(DataType || (DataType = {}));
/**
 * 判断变量的数据类型
 * @param {unknown} val 变量值
 * @returns {string} 数据类型
 */
function getType(val) {
    return Object.prototype.toString
        .call(val)
        .replace(/\[object\s(\w+)\]/, '$1')
        .toLowerCase();
}
function isObject(val) {
    return getType(val) === DataType.Object;
}
function isArray(val) {
    return Array.isArray(val);
}
function isNumber(val) {
    return typeof val === DataType.Number;
}
function isString(val) {
    return typeof val === DataType.String;
}
function isBool(val) {
    return typeof val === DataType.Boolean;
}
function isUndefined(val) {
    return val === undefined;
}
function isNull(val) {
    return val === null;
}
function isFunction(val) {
    return typeof val === DataType.Function;
}
function isSymbol(val) {
    return typeof val === DataType.Symbol;
}
function isMap(val) {
    return getType(val) === DataType.Map;
}
function isSet(val) {
    return getType(val) === DataType.Set;
}
function isPromise(val) {
    return getType(val) === DataType.Promise;
}
function isFile(val) {
    return val instanceof File;
}
function isBlob(val) {
    return val instanceof Blob;
}
function isBasicType(val) {
    const type = getType(val);
    return [DataType.Number, DataType.Boolean, DataType.String, DataType.Symbol, DataType.Undefined, DataType.Null].includes(type);
}
function isUndefOrNull(val) {
    return isUndefined(val) || isNull(val);
}
/**
 * 判断变量是否有具体定义，即非null,非undefined,非空字符串
 * @param {unknown} val 变量值
 * @returns {boolean} 变量是否有具体定义
 */
function isDefined(val) {
    return val !== null && val !== undefined && val !== '';
}

export { getType, isArray, isBasicType, isBlob, isBool, isDefined, isFile, isFunction, isMap, isNull, isNumber, isObject, isPromise, isSet, isString, isSymbol, isUndefOrNull, isUndefined };
